/**
 * kult-b2b-event-request.js — Team-Event-Anfrage mit Preisrechner (B2B).
 * Format (Preis p. P., Ort) → Personen (Stepper min/max) → Termin (Rösterei: Kalender nur an erlaubten
 * Wochentagen ohne gesperrte/B2C-Tage, ab Vorlauf; vor Ort: freies Datum) → Kontakt → Senden.
 * Zusammenfassung und Schätzpreis rechnen live; Termin/Preis gehen als versteckte Felder mit.
 * Nach dem Post (#kult-evreq-…) wird zum Status gescrollt.
 */
(function () {
  'use strict';
  if (customElements.get('kult-event-request')) return;

  var MONTHS = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  var fmtLong = new Intl.DateTimeFormat('de-DE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
  var fmtShort = new Intl.DateTimeFormat('de-DE', { weekday: 'short', day: '2-digit', month: '2-digit', year: 'numeric' });
  function money(cents) { return (cents / 100).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' }); }
  function ymd(d) { return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0'); }
  function toDate(iso) { var p = iso.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); }

  class KultEventRequest extends HTMLElement {
    connectedCallback() {
      try { this.blocked = JSON.parse((this.querySelector('[data-evreq-blocked]') || {}).textContent || '[]'); } catch (e) { this.blocked = []; }
      this.min = parseInt(this.dataset.min, 10) || 5;
      this.max = parseInt(this.dataset.max, 10) || 10;
      this.maxInhouse = parseInt(this.dataset.maxInhouse, 10) || 15;
      this.weekdays = (this.dataset.weekdays || '1,6').split(',').map(function (x) { return parseInt(x, 10); });
      /* Uhrzeiten je Wochentag (04.10.2026): "1=12:00,17:00;6=15:00" → { 1: ['12:00','17:00'], 6: ['15:00'] } */
      this.timesByDay = {};
      (this.dataset.timesByDay || '').split(';').forEach(function (part) {
        var kv = part.split('='), day = parseInt(kv[0], 10);
        var list = (kv[1] || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
        if (!isNaN(day) && list.length) this.timesByDay[day] = list;
      }, this);
      var ts = this.querySelector('[data-evreq-time]');
      this.defaultTimes = ts ? Array.from(ts.options).map(function (o) { return o.value; }) : [];
      this.leadDays = parseInt(this.dataset.leadDays, 10) || 0;
      this.months = parseInt(this.dataset.months, 10) || 8;
      /* Ganze Monate ausgebucht (Setting blocked_months, 1–12, jedes Jahr) */
      this.blockedMonths = (this.dataset.blockedMonths || '').split(',').map(function (x) { return parseInt(x, 10); }).filter(function (m) { return m >= 1 && m <= 12; });
      this.today = new Date(); this.today.setHours(0, 0, 0, 0);
      this.minDate = new Date(this.today); this.minDate.setDate(this.minDate.getDate() + this.leadDays);
      /* Zeitraum bis zum Monatsende: months = 14 ab Oktober → Ende November des Folgejahres */
      this.maxDate = new Date(this.today.getFullYear(), this.today.getMonth() + this.months, 0);
      this.selectedDate = null;
      var probe = new Date(this.minDate), guard = 0;
      while (guard++ < 400 && probe <= this.maxDate && !this.isFree(probe)) probe.setDate(probe.getDate() + 1);
      this.view = { y: probe.getFullYear(), m: probe.getMonth() };

      this.form = this.querySelector('form');
      this.people = this.querySelector('[data-evreq-people]');
      this.addEventListener('click', this._onClick.bind(this));
      this.addEventListener('change', this._onChange.bind(this));
      this.addEventListener('input', this._onChange.bind(this));
      if (this.form) this.form.addEventListener('submit', this._onSubmit.bind(this));
      var inDate = this.querySelector('[data-evreq-inhouse-date]');
      if (inDate) inDate.min = ymd(this.minDate);

      this.renderMonth();
      this.update();

    }

    /* ---------- Zustand ---------- */
    format() { return this.querySelector('[data-evreq-format]:checked'); }
    isInhouse() { var f = this.format(); return !!(f && f.dataset.place === 'inhouse'); }
    isFree(date) {
      if (date < this.minDate || date > this.maxDate) return false;
      if (this.weekdays.indexOf(date.getDay()) === -1) return false;
      if (this.monthFull(date)) return false;
      return this.blocked.indexOf(ymd(date)) === -1;
    }
    monthFull(date) { return this.blockedMonths.indexOf(date.getMonth() + 1) !== -1; 
    }

    /* ---------- Kalender ---------- */
    renderMonth() {
      var grid = this.querySelector('[data-evreq-days]'), label = this.querySelector('[data-evreq-month-label]');
      if (!grid) return;
      var y = this.view.y, m = this.view.m;
      if (label) label.textContent = MONTHS[m] + ' ' + y;
      var offset = (new Date(y, m, 1).getDay() + 6) % 7, days = new Date(y, m + 1, 0).getDate(), html = '';
      for (var i = 0; i < offset; i++) html += '<span class="kult-evreq__day" aria-hidden="true"></span>';
      for (var d = 1; d <= days; d++) {
        var date = new Date(y, m, d), iso = ymd(date), free = this.isFree(date);
        var inRange = this.weekdays.indexOf(date.getDay()) !== -1 && date >= this.minDate && date <= this.maxDate;
        var full = inRange && this.monthFull(date);
        var blocked = inRange && !full && this.blocked.indexOf(iso) !== -1;
        var why = full ? 'Ausgebucht' : (blocked ? 'Offenes Seminar, nicht verfügbar' : '');
        if (free) html += '<button type="button" class="kult-evreq__day kult-evreq__day--free" data-evreq-day="' + iso + '" aria-pressed="' + (this.selectedDate === iso ? 'true' : 'false') + '" aria-label="' + fmtLong.format(date) + '">' + d + '</button>';
        else html += '<span class="kult-evreq__day' + (why ? ' kult-evreq__day--blocked' : '') + (full ? ' kult-evreq__day--full' : '') + '"' + (why ? ' title="' + why + '"' : '') + '>' + d + '</span>';
      }
      grid.innerHTML = html;
      var note = this.querySelector('[data-evreq-month-note]');
      if (note) {
        var monthFull = this.blockedMonths.indexOf(m + 1) !== -1;
        if (monthFull && !note.dataset.tpl) note.dataset.tpl = note.textContent;
        if (monthFull) note.textContent = (note.dataset.tpl || '').replace('{monat}', MONTHS[m]);
        note.hidden = !monthFull;
      }
      var prev = this.querySelector('[data-evreq-month="-1"]'), next = this.querySelector('[data-evreq-month="1"]');
      if (prev) prev.disabled = (y < this.minDate.getFullYear()) || (y === this.minDate.getFullYear() && m <= this.minDate.getMonth());
      if (next) next.disabled = (y > this.maxDate.getFullYear()) || (y === this.maxDate.getFullYear() && m >= this.maxDate.getMonth());
    }

    /* Uhrzeit-Auswahl an den gewählten Tag anpassen (z. B. montags 12 und 17 Uhr, samstags nur 15 Uhr) */
    refreshTimes(sel) {
      var day = this.selectedDate ? toDate(this.selectedDate).getDay() : -1;
      var list = (this.timesByDay[day] || []).map(function (t) { return /Uhr$/.test(t) ? t : t + ' Uhr'; });
      if (!list.length) list = this.defaultTimes;
      var key = list.join('|');
      if (sel.dataset.timesKey === key) return;
      var keep = sel.value;
      sel.innerHTML = '';
      list.forEach(function (t) { var o = document.createElement('option'); o.value = t; o.textContent = t; sel.appendChild(o); });
      if (list.indexOf(keep) !== -1) sel.value = keep;
      sel.dataset.timesKey = key;
    }

    /* ---------- Zusammenfassung + Preis ---------- */
    update() {
      var f = this.format(), inhouse = this.isInhouse();
      var roast = this.querySelector('[data-evreq-roastery]'), inh = this.querySelector('[data-evreq-inhouse]');
      if (roast) roast.hidden = inhouse;
      if (inh) inh.hidden = !inhouse;
      var timeSel = this.querySelector('[data-evreq-time]'), addr = this.querySelector('[data-evreq-address]'), iDate = this.querySelector('[data-evreq-inhouse-date]'), iTime = this.querySelector('[data-evreq-inhouse-time]');
      if (timeSel) { timeSel.required = !inhouse; this.refreshTimes(timeSel); }
      if (addr) addr.required = inhouse;
      if (iDate) iDate.required = inhouse;
      if (iTime) iTime.required = inhouse;

      var cap = inhouse ? this.maxInhouse : this.max;
      var n = Math.max(this.min, Math.min(cap, parseInt(this.people && this.people.value, 10) || this.min));
      if (this.people) { this.people.value = String(n); this.people.max = String(cap); }
      var minus = this.querySelector('[data-evreq-step="-1"]'), plus = this.querySelector('[data-evreq-step="1"]');
      if (minus) minus.disabled = n <= this.min;
      if (plus) plus.disabled = n >= cap;

      var price = f ? parseInt(f.dataset.price, 10) || 0 : 0;
      var set = function (sel, val) { var el = document.querySelector(sel); if (el) el.textContent = val; };
      var scope = this;
      var q = function (sel) { return scope.querySelector(sel); };
      if (q('[data-evreq-sum-format]')) q('[data-evreq-sum-format]').textContent = f ? f.value : '–';
      if (q('[data-evreq-sum-people]')) q('[data-evreq-sum-people]').textContent = n + ' Personen';
      if (q('[data-evreq-sum-place]')) q('[data-evreq-sum-place]').textContent = inhouse ? 'Bei Ihnen vor Ort' : 'Kult Rösterei & Café, Menden';

      var dateText = '–', dateField = '';
      if (inhouse) {
        var dv = iDate && iDate.value, tv = iTime && iTime.value;
        if (dv) { dateText = fmtShort.format(toDate(dv)) + (tv ? ', ' + tv + ' Uhr' : ''); dateField = dateText; }
      } else if (this.selectedDate) {
        var t = timeSel ? timeSel.value : '';
        dateText = fmtShort.format(toDate(this.selectedDate)) + (t ? ', ' + t : ''); dateField = dateText;
      }
      if (q('[data-evreq-sum-date]')) q('[data-evreq-sum-date]').textContent = dateText;
      var df = q('[data-evreq-date-field]'); if (df) df.value = dateField;

      var calc = q('[data-evreq-sum-calc]'), total = q('[data-evreq-sum-total]'), pf = q('[data-evreq-price-field]');
      if (price > 0) {
        if (calc) calc.textContent = n + ' × ' + money(price);
        if (total) total.textContent = money(price * n);
        if (pf) pf.value = n + ' × ' + money(price) + ' = ' + money(price * n) + ' (Schätzung)';
      } else {
        if (calc) calc.textContent = 'Preis';
        if (total) total.textContent = 'auf Anfrage';
        if (pf) pf.value = 'auf Anfrage';
      }
      var err = q('[data-evreq-date-error]'); if (err && (inhouse || this.selectedDate)) err.hidden = true;
      void set;
    }

    /* ---------- Events ---------- */
    _onClick(e) {
      var nav = e.target.closest('[data-evreq-month]');
      if (nav) { var m = this.view.m + parseInt(nav.dataset.evreqMonth, 10), y = this.view.y; if (m < 0) { m = 11; y--; } else if (m > 11) { m = 0; y++; } this.view = { y: y, m: m }; this.renderMonth(); return; }
      var day = e.target.closest('[data-evreq-day]');
      if (day) { this.selectedDate = day.dataset.evreqDay; this.renderMonth(); this.update(); return; }
      var step = e.target.closest('[data-evreq-step]');
      if (step && this.people) { this.people.value = String((parseInt(this.people.value, 10) || this.min) + parseInt(step.dataset.evreqStep, 10)); this.update(); }
    }

    _onChange(e) {
      if (e.target.closest('[data-evreq-format], [data-evreq-people], [data-evreq-time], [data-evreq-inhouse-date], [data-evreq-inhouse-time]')) this.update();
    }

    /* Versand über die App (assets/kult-b2b-lead.js), nie über den Browser: kein Seitenwechsel, keine weiße Seite */
    _onSubmit(e) {
      e.preventDefault();
      if (this._sending) return;
      this.update();
      if (!this.isInhouse() && !this.selectedDate) {
        var err = this.querySelector('[data-evreq-date-error]');
        if (err) { err.hidden = false; err.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
        return;
      }
      /* sichtbare Pflichtfelder (versteckte Felder zählen nicht, sie lassen sich nicht ausfüllen) */
      var bad = Array.prototype.filter.call(this.form.elements, function (el) { return el.willValidate && el.offsetParent !== null && !el.checkValidity(); })[0];
      if (bad) { if (typeof bad.reportValidity === 'function') bad.reportValidity(); else bad.focus(); return; }
      this._send();
    }

    _send() {
      var self = this, form = this.form;
      var btn = form.querySelector('button[type="submit"], input[type="submit"]');
      var box = this.querySelector('[data-evreq-errors]');
      var lead = window.KultB2BLead;
      this._sending = true;
      if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
      if (box) box.hidden = true;
      (lead && typeof lead.submit === 'function' ? lead.submit(form) : Promise.resolve({ ok: false, error: '' })).then(function (result) {
        self._sending = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        if (result && result.ok) {
          var ok = self.querySelector('[data-evreq-success]');
          form.classList.add('is-sent');
          if (ok) { ok.hidden = false; ok.focus({ preventScroll: true }); ok.scrollIntoView({ block: 'center' }); }
          return;
        }
        if (box) {
          var text = box.querySelector('[data-evreq-errors-text]') || box;
          text.textContent = (result && result.error) || 'Ihre Anfrage konnte gerade nicht gesendet werden. Bitte versuchen Sie es gleich noch einmal oder schreiben Sie uns eine E-Mail.';
          box.hidden = false;
          box.scrollIntoView({ block: 'center' });
        }
      });
    }
  }

  customElements.define('kult-event-request', KultEventRequest);
})();
